var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('HeaderCmp'),_c('main',{staticClass:"main"},[_c('router-view',{key:_vm.$route.path})],1),_c('page-loader-cmp'),_c('FooterCmp',{staticClass:"footer"}),_c('CommonIcons')],1)}
var staticRenderFns = []

export { render, staticRenderFns }